import { Pipe, PipeTransform } from '@angular/core'

import { Authentication } from 'core/auth'

@Pipe({ name: 'privateUploadUrl' })
export class PrivateUploadUrlPipe implements PipeTransform {
  constructor(private authentication: Authentication) {}

  transform(value: string): string {
    let authParams = new URLSearchParams()
    let authData = this.authentication.currentAuthData
    let sep = value.indexOf('?') > -1 ? '&' : '?'
    authParams.set('uid', authData.uid)
    authParams.set('client', authData.client)
    authParams.set('access-token', authData.accessToken)

    return `${value}${sep}${authParams.toString()}`
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/common/pipes/private-upload-url.pipe.ts